import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink, FormFeedback } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

import Api from '../../../api'

class ForgetPw extends Component {
  
  constructor(props) {
    super(props)

    this.state = {
      acc: "",
      controller: "",
      fname: "",
      lname: "",
      phone: "",
      pwd: "",
      npwd: "",
      rnpwd: "",
      msg: '',
      credits: 0,
    }

    new Api().load((succ, item) => {
      this.setState({acc: item.email, fname: item.first_name, lname: item.last_name, phone: item.phone, controller: item.controller, credits: item.credits})
    })
  }

  save() {
    if(this.state.pwd.length == 0 && (this.state.npwd.length != 0 || this.state.rnpwd.length != 0)) {
      alert("You must provide a valid current password");
      return;
    }

    if(this.state.npwd != this.state.rnpwd) {
      alert("Password confirmation doesn't match New Password");
      return;
    }

    var api = new Api()
    api.saveAcc(this.state.acc, this.state.npwd, this.state.controller, this.state.fname, this.state.lname, (succ, item) => {
      if(succ) {
        alert("Account updated.");
        window.location.reload();
      } else {
        alert(item);
      }
    });
  }

  change() {
    this.setState({msg:'Checking.... Step 1'})
    var api = new Api()
      // api.checkDevice(this.state.phone, 1, (succ, err) => {
      //   if(succ) {
      //       this.setState({msg:'Checking.... Step 2'});
            api.checkDevice(this.state.phone, 2, (succ, err) => {
              if(succ) {
                if(err.val.toLowerCase().indexOf("off") != -1) {
                  this.setState({msg:'Checking.... Step 2'});
                  api.checkDevice(this.state.phone, 3, (succ, err) => {
                    if(succ) {
                      if(err.val.toLowerCase().indexOf("on") != -1 && err.val.toLowerCase().indexOf("number set") != -1) {
                        api.changePhone(this.state.acc, this.state.phone, (succ, item) => {
                          this.setState({msg:''})
                          if(succ) {
                            alert("Account updated.");
                          } else {
                            alert(err);
                          }
                        });
                      } else {
                        this.setState({msg:''})
                        if(err.val.toLowerCase().indexOf("number set") != -1) {
                          alert("Please turn on emergency mode at SOS Setting>SOS mode setting>On>OK.");
                        } else {
                          alert("Please setup your emergency contact number at SOS Setting>SOS numbers.");
                        }
                      }
                    } else {
                      this.setState({msg:''})
                      alert(err);
                    }
                  })
                } else {
                  this.setState({msg:''})
                  alert("Please make sure you are using VOCA V330 or V530 cell phone. If you are, please turn off DND at Settings>DND>Off>OK.");
                }
              } else {
                this.setState({msg:''})
                if(err == null) { 
                  alert("Please make sure you are using VOCA V330 or V530 cell phone. If you are, please turn off DND at Settings>DND>Off>OK.");
                } else {
                  alert(err);
                }
              }
            });
          
        // } else {
        //   this.setState({msg:''})
        //   if(err == null) {
        //     alert("Your phone is not V530 or V330 with the latest software version. Please contact us.");
        //   } else {
        //     alert(err);
        //   }
        // }
      // });
  }

  render() {
    return (
      <LoadingOverlay
        active={this.state.msg.length > 0}
        spinner
        text={this.state.msg}
        >
      <div className="app align-items-center mcg">
        <span className="frontbk" style={{zIndex:"0"}}  />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
              <Card className="md-0">
                <Menu/>

                <CardHeader className="sihead">
                  <h1>My Settings</h1>
                  <p className="text-center mb-0">
                    1. Please click <NavLink className="inline-link" href="/help"><b>here</b></NavLink> for the compatible phone list. <br />2. You may check the phone readiness by pressing CHECK MY PHONE READINESS button. Please make sure you have insert a standard SIM card and turn on the cell phone before you press the button. <br />3.  Voice credit  is needed for smart speakers to issue command to cell phone.
                  </p>
                </CardHeader>
                <CardBody className="login-form text-center logbox chgpw">
                  <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input type="text" placeholder="Firstname" value={this.state.fname} autoComplete="firstname" onChange={(evt) => { this.setState({fname: evt.target.value}); }} required/>
                        <Input type="text" placeholder="Lastname" value={this.state.lname} autoComplete="lastname" onChange={(evt) => { this.setState({lname: evt.target.value}); }} required/>
                      </InputGroup>
                      <div className="wraning-msg">
                        {/* Warning message for LoginID */}
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-phone" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="phone" value={this.state.phone} placeholder="Cell Number" autoComplete="false" onChange={(evt) => { this.setState({phone: evt.target.value}); }} />
                  </InputGroup>
                  <div className="wraning-msg">
                    {/* Warning message for LoginID */}
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="password" value={this.state.pwd} placeholder="Current Password" autoComplete="false"  onChange={(evt) => { this.setState({pwd: evt.target.value}); }}/>
                  </InputGroup>
                  <div className="wraning-msg">
                    {/* Warning message for LoginID */}
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="password" value={this.state.npwd} placeholder="New Password" autoComplete="false"  onChange={(evt) => { this.setState({npwd: evt.target.value}); }}/>
                  </InputGroup>
                  <div className="wraning-msg">
                    {/* Warning message for LoginID */}
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="icon-lock" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input type="password" value={this.state.rnpwd} placeholder="Password confirmation" autoComplete="false"  onChange={(evt) => { this.setState({rnpwd: evt.target.value}); }}/>
                  </InputGroup>
                  <div className="wraning-msg">
                    {/* Warning message for LoginID */}
                    {this.state.msg}
                  </div>
                  <Row>
                    <Col>
                      <Button color="primary" className="px-4 btn-brand" onClick={this.change.bind(this)}>Check my phone readiness</Button>
                      <p></p>
                      <Button outline className="px-4 btn-outline" color="primary" onClick={this.save.bind(this)}>Save Changes</Button>
                      <p></p>
                      <p><b>Available Voice Credit : {this.state.credits}</b></p>
                      { this.state.credits <= 0 &&
                      <p><b>You have used all your voice credit. Please contact us for further voice credit</b></p> }
                    </Col>
                  </Row>
                </CardBody>
              </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"2"}}>
          <CRNote/>
        </Container>
      </div>
      </LoadingOverlay>
    );
  }
}

export default ForgetPw;



// WEBPACK FOOTER //
// ./src/views/Pages/ChangePw/ChangePw.js